import debug from 'debug';

const log = debug('SitecoreApi');

class SitecoreApi {
	get(url) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/json'
				},
				credentials: 'include'
			}).then(response => {
				log('get()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('get() - ERROR', error);
				reject(error);
			});
		});
	}

	post(url, body) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				credentials: 'same-origin',
				body
			}).then(response => {
				log('post()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('post() - ERROR', error);
				reject(error);
			});
		});
	}
}

export default SitecoreApi;
